import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ts-micro-protocol-header',
    templateUrl: './micro-protocol-header.component.html',
    styleUrls: ['./micro-protocol-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MicroProtocolHeaderComponent {
  @Input() categoryId!: string;
  @Input() collapsed = false;
  @Input() title = '';
  @Input() assetTotalCount = 0;
  @Input() assetTotalPct = 0;
  @Input() sampleTotalCount = 0;
  @Input() sampleTotalPct = 0;
  @Input() showAddLabel = false;
}
